import React, { useState } from 'react';
import { convertToDateDefault, convertToDateDefaultWithHours } from 'js/library/utils/helpers';
import cfac22 from 'js/library/utils/cfac22';

// Styles
import {
  Box,
  CircularProgress,
  IconButton,
  MenuItem,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import { DotsThreeVertical, File, Files, FileX, ListChecks, UserList } from 'phosphor-react';
import { MenuIconButton, StyledMenu } from '../../Campaigns/ListCampaigns/styles';

// Components
import { ModalBudgetSummary } from './ModalBudgetSummary';
import { ModalCancelMessage } from './ModalCancelMessage';
import usePagination from 'js/components/TriiboComponents/Tables/usePagination';
import { toast } from 'react-toastify';

export const TableQuotes = ({ data, loading, reload, userPoints }) => {
  const columns = [
    'Data da solicitação',
    'Data planejada',
    'Identificador da mensagem',
    // 'Canal de comunicação',
    'Usuários selecionados',
    'Custo do envio orçado/realizado',
    'Status',
    'Ações',
  ];
  const PER_PAGE = 10;
  const sortedData = [...data].sort((a, b) => new Date(b.creationDate) - new Date(a.creationDate));
  const _DATA = usePagination(sortedData, PER_PAGE);
  const count = Math.ceil(data.length / PER_PAGE);

  const [menus, setMenus] = useState({});
  const [modalBudgetIsOpen, setModalBudgetIsOpen] = useState(false);
  const [modalCancelIsOpen, setModalCancelIsOpen] = useState(false);
  const [selectedBudget, setSelectedBudget] = useState(null);

  const handleChangePage = (e, p) => {
    _DATA.jump(p);
  };

  const handleClick = (event, id) => {
    setMenus((prevMenus) => ({
      ...prevMenus,
      [id]: event.currentTarget,
    }));
  };

  const handleClose = (id) => {
    setMenus((prevMenus) => ({
      ...prevMenus,
      [id]: null,
    }));
  };

  const handleModalBudgetOrCancel = (budgetResume, type) => {
    switch (type) {
      case 'approve':
        setSelectedBudget(budgetResume);
        setModalBudgetIsOpen(true);
        break;
      case 'cancel':
        setSelectedBudget(budgetResume);
        setModalCancelIsOpen(true);
        break;
      default:
        console.error('Tipo de ação inválido:', type);
    }
  };

  const sanitizeStatus = (status) => {
    switch (status) {
      case 'created':
        return 'Mensagem criada';
      case 'processing':
        return 'Processando';
      case 'sended':
        return 'Orçamento aprovado';
      case 'canceled':
        return 'Orçamento cancelado';
      case 'completed':
        return 'Finalizado';
      default:
        return status;
    }
  };

  return (
    <>
      <TableContainer>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', height: '300px' }}>
            <CircularProgress thickness={5} size={50} />
          </div>
        ) : (
          <Table sx={{ minWidth: 650 }} size="medium">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell align="center" key={column}>
                    <strong>{column}</strong>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {_DATA
                .currentData()
                .map(
                  ({
                    channel,
                    creationDate,
                    filePath,
                    id,
                    qtyParticipants,
                    title,
                    scheduleDate,
                    status,
                    value,
                  }) => (
                    <TableRow key={id}>
                      <TableCell align="center">{convertToDateDefault(creationDate)}</TableCell>
                      <TableCell align="center">
                        {convertToDateDefaultWithHours(scheduleDate)}
                      </TableCell>
                      <TableCell align="center">{title}</TableCell>
                      {/*  <TableCell align="center">
                        {channel ? Object.keys(channel)[0] : 'N/C'}
                      </TableCell> */}
                      <TableCell align="center">{qtyParticipants ?? 'N/C'}</TableCell>
                      <TableCell align="center">{value ?? 'N/C'}</TableCell>
                      <TableCell align="center">{sanitizeStatus(status)}</TableCell>
                      <TableCell align="center">
                        {status !== 'canceled' && (
                          <IconButton
                            id={`menu-button-${id}`}
                            aria-controls={menus[id] ? `menu-${id}` : undefined}
                            aria-haspopup="true"
                            onClick={(event) => handleClick(event, id)}
                            sx={{
                              backgroundColor: '#ebe6ea',
                              borderRadius: '50px',
                              color: 'gray',
                              '&:hover': { color: '#6e3296' },
                            }}
                          >
                            <DotsThreeVertical size={28} weight="bold" />
                          </IconButton>
                        )}
                        <StyledMenu
                          id={`menu-${id}`}
                          anchorEl={menus[id]}
                          open={Boolean(menus[id])}
                          onClose={() => handleClose(id)}
                          MenuListProps={{
                            'aria-labelledby': `menu-button-${id}`,
                          }}
                        >
                          <MenuItem
                            onClick={async () => {
                              const url =
                                cfac22('STORAGE_URL') + encodeURIComponent(filePath) + '?alt=media';

                              try {
                                const response = await fetch(url);
                                const blob = await response.blob();
                                const downloadUrl = window.URL.createObjectURL(blob);

                                const link = document.createElement('a');
                                link.href = downloadUrl;

                                link.download = `Arquivo: ${title}`;

                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);

                                window.URL.revokeObjectURL(downloadUrl);
                              } catch (error) {
                                console.error('Erro ao fazer o download:', error);
                              }
                              handleClose(id);
                            }}
                            disableRipple
                          >
                            <MenuIconButton to="#">
                              <UserList size={20} weight="bold" />
                              Lista de usuários
                            </MenuIconButton>
                          </MenuItem>
                          {status === 'created' && [
                            <Tooltip
                              placement="right"
                              title={userPoints <= 0 ? 'Clube sem pontos disponíveis.' : ''}
                              disableHoverListener={userPoints > 0} // evita mostrar tooltip se não estiver desabilitado
                            >
                              <Box component="span">
                                <MenuItem
                                  disabled={userPoints <= 0}
                                  onClick={() => {
                                    if (userPoints <= 0) {
                                      toast.error('Clube sem pontos disponíveis.');
                                      return;
                                    }
                                    handleModalBudgetOrCancel(
                                      {
                                        communicationMessageId: id,
                                        resumeQuote: {
                                          channel: channel ? Object.keys(channel)[0] : null,
                                          totalUsers: qtyParticipants,
                                          totalCost: value,
                                        },
                                      },
                                      'approve'
                                    );
                                    handleClose(id);
                                  }}
                                  disableRipple
                                >
                                  <MenuIconButton to="#">
                                    <ListChecks size={20} weight="bold" />
                                    Aprovar orçamento
                                  </MenuIconButton>
                                </MenuItem>
                              </Box>
                            </Tooltip>,
                            <MenuItem
                              disableRipple
                              onClick={() => {
                                handleModalBudgetOrCancel(
                                  {
                                    communicationMessageId: id,
                                  },
                                  'cancel'
                                );
                                handleClose(id);
                              }}
                            >
                              <MenuIconButton to="#">
                                <FileX size={20} weight="bold" />
                                Cancelar orçamento
                              </MenuIconButton>
                            </MenuItem>,
                          ]}
                          {status === 'sended' && (
                            <MenuItem
                              onClick={() => {
                                handleModalBudgetOrCancel(
                                  {
                                    isRelatory: true,
                                    communicationMessageId: id,
                                    resumeQuote: {
                                      channel: channel ? Object.keys(channel)[0] : null,
                                      totalUsers: qtyParticipants,
                                      totalCost: value,
                                    },
                                  },
                                  'approve'
                                );
                                handleClose(id);
                              }}
                              disableRipple
                            >
                              <MenuIconButton to="#">
                                <File size={20} weight="bold" />
                                Orçamento
                              </MenuIconButton>
                            </MenuItem>
                          )}
                          {status === 'completed' && (
                            <MenuItem
                              onClick={() => {
                                handleModalBudgetOrCancel(
                                  {
                                    isFinalRelatory: true,
                                    communicationMessageId: id,
                                  },
                                  'approve'
                                );
                                handleClose(id);
                              }}
                              disableRipple
                            >
                              <MenuIconButton to="#">
                                <Files size={20} weight="bold" />
                                Relatório de envio
                              </MenuIconButton>
                            </MenuItem>
                          )}
                        </StyledMenu>
                      </TableCell>
                    </TableRow>
                  )
                )}
            </TableBody>
          </Table>
        )}
        <ModalBudgetSummary
          budgetResume={selectedBudget}
          close={() => setModalBudgetIsOpen(false)}
          open={modalBudgetIsOpen}
          reload={reload}
          subsequentApproval={true}
          userPoints={userPoints}
        />
        <ModalCancelMessage
          budgetResume={selectedBudget}
          close={() => setModalCancelIsOpen(false)}
          open={modalCancelIsOpen}
          reload={reload}
        />
      </TableContainer>
      <Pagination count={count} onChange={handleChangePage} />
    </>
  );
};
